const rankingData = [
  { rank: 1, title: '某知名艺人深夜密会神秘人士，新恋情浮出水面', tag: '娱乐圈', hot: '325万', change: 'up' },
  { rank: 2, title: '某互联网公司大规模裁员传闻持续发酵，内部员工集体维权', tag: '科技', hot: '289万', change: 'up' },
  { rank: 3, title: '某地食品安全抽检多家知名品牌不合格，监管部门约谈', tag: '社会', hot: '256万', change: 'new' },
  { rank: 4, title: '某上市公司遭做空机构狙击，财务造假疑云密布', tag: '财经', hot: '218万', change: 'up' },
  { rank: 5, title: '国际赛事争议判罚持续发酵，多方呼吁改革裁判制度', tag: '体育', hot: '195万', change: 'down' },
  { rank: 6, title: '两国闭门会谈内幕曝光，涉及敏感贸易协定条款', tag: '国际', hot: '172万', change: 'new' },
  { rank: 7, title: '某综艺录制现场突发意外，嘉宾受伤引发安全讨论', tag: '娱乐圈', hot: '158万', change: 'down' },
];

export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-fire-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">爆料热度榜</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">实时热度排行 · 全网爆料风向标</p>

        <div className="ml-11 bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 hover:bg-background-200/40 transition-colors group cursor-pointer ${
                i !== rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors leading-relaxed truncate">
                  {item.title}
                </p>
              </div>

              <div className="flex-shrink-0 hidden sm:block">
                <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded">{item.tag}</span>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1 text-sm">
                {item.change === 'up' && <i className="ri-arrow-up-line text-primary-500 text-xs"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-secondary-500 text-xs"></i>}
                {item.change === 'new' && <span className="text-xs bg-accent-100 text-accent-600 px-1.5 py-0.5 rounded font-medium">NEW</span>}
                <span className="text-foreground-500 font-medium text-sm">{item.hot}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const indexData = [
  { letter: 'A', title: '娱乐圈爆料', desc: '明星八卦、恋情曝光、合约纠纷', count: '1,286条' },
  { letter: 'B', title: '社会热点追踪', desc: '民生事件、维权报道、公共安全', count: '954条' },
  { letter: 'C', title: '科技行业内幕', desc: '互联网公司、裁员动态、产品揭秘', count: '732条' },
  { letter: 'D', title: '财经市场风向', desc: '上市公司、做空报告、高管变动', count: '615条' },
  { letter: 'E', title: '体育赛事争议', desc: '裁判判罚、转会传闻、选手动态', count: '498条' },
  { letter: 'F', title: '国际时事解读', desc: '外交关系、政要动态、全球趋势', count: '423条' },
  { letter: 'G', title: '生活消费警示', desc: '食品安全、产品质量、行业黑幕', count: '387条' },
];

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-bookmark-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">爆料主题索引</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">按主题快速定位 · 精准找到你感兴趣的内容</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {indexData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 hover:border-primary-200/70 transition-all group cursor-pointer flex items-start gap-4"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <span className="text-primary-600 font-heading font-bold text-lg">{item.letter}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base text-foreground-900 group-hover:text-primary-600 transition-colors mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-1.5">{item.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{item.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const topicsData = [
  { tag: '#娱乐圈大瓜', heat: '火热', count: '1.2万讨论' },
  { tag: '#互联网裁员', heat: '火爆', count: '9,865讨论' },
  { tag: '#食品安全', heat: '热议', count: '8,430讨论' },
  { tag: '#股市风云', heat: '火热', count: '7,250讨论' },
  { tag: '#体育争议', heat: '热议', count: '6,180讨论' },
  { tag: '#国际局势', heat: '上升', count: '5,640讨论' },
  { tag: '#明星恋情', heat: '火热', count: '5,120讨论' },
  { tag: '#维权事件', heat: '热议', count: '4,890讨论' },
  { tag: '#消费陷阱', heat: '上升', count: '4,350讨论' },
  { tag: '#政策解读', heat: '上升', count: '3,920讨论' },
];

export function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-hashtag text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热门话题标签</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">全网热议话题一网打尽 · 吃瓜就要趁热</p>

        <div className="flex flex-wrap gap-3 ml-11">
          {topicsData.map((item, i) => (
            <div
              key={i}
              className="group cursor-pointer"
            >
              <div className={`px-4 py-3 rounded-xl border transition-all hover:scale-105 ${
                item.heat === '火热' ? 'bg-primary-50 border-primary-200 hover:border-primary-400 text-primary-700' :
                item.heat === '火爆' ? 'bg-primary-100 border-primary-300 hover:border-primary-500 text-primary-800' :
                item.heat === '热议' ? 'bg-accent-50 border-accent-200 hover:border-accent-400 text-accent-700' :
                'bg-secondary-50 border-secondary-200 hover:border-secondary-400 text-secondary-700'
              }`}>
                <div className="font-semibold text-sm md:text-base whitespace-nowrap">{item.tag}</div>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${
                    item.heat === '火热' ? 'bg-primary-200 text-primary-700' :
                    item.heat === '火爆' ? 'bg-primary-300 text-primary-800' :
                    item.heat === '热议' ? 'bg-accent-200 text-accent-700' :
                    'bg-secondary-200 text-secondary-700'
                  }`}>{item.heat}</span>
                  <span className="text-xs opacity-60">{item.count}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20person%2C%20warm%20lighting%2C%20clean%20neutral%20background%2C%20friendly%20expression%2C%20natural%20professional%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜第一线',
    time: '2小时前',
    text: '一直在追这个爆料，终于等到完整版了！爆料网的更新速度真的快，比51爆料网还及时。现在每天第一件事就是打开爆料网看最新动态。',
    likes: 1286,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20of%20young%20Chinese%20woman%2C%20warm%20natural%20lighting%2C%20simple%20cream%20background%2C%20friendly%20smile%2C%20modern%20lifestyle%20photography%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '真相追踪者',
    time: '5小时前',
    text: '之前9-11爆料网打不开急死我了，还好发现了爆料网这个宝藏平台，内容又快又全，还有App推送功能，再也不会错过任何大瓜了！',
    likes: 963,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle-aged%20Chinese%20man%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20confident%20expression%2C%20business%20casual%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '深度观察员',
    time: '8小时前',
    text: '作为老吃瓜群众，爆料网的内容质量确实高。编辑团队很用心，不是简单搬运，每条爆料都有独立核实和深度解读。推荐大家都来关注！',
    likes: 742,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Natural%20portrait%20of%20young%20Chinese%20student%2C%20warm%20outdoor%20lighting%2C%20soft%20background%2C%20genuine%20smile%2C%20casual%20contemporary%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '吃瓜小能手',
    time: '12小时前',
    text: '爆料网的分类做得特别好，娱乐圈、科技、财经分得很清楚。我想看什么类型的瓜直接点分类就行，比在其他平台翻半天省心多了。',
    likes: 531,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20Chinese%20professional%20woman%2C%20warm%20indoor%20lighting%2C%20neutral%20background%2C%20approachable%20expression%2C%20modern%20office%20style&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '每日爆料迷',
    time: '1天前',
    text: '从91爆料网那边过来的，发现爆料网这边内容更丰富，更新也更快。App体验也很流畅，已经推荐给身边所有吃瓜的朋友了！',
    likes: 428,
  },
];

export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 rounded-lg bg-accent-500 flex items-center justify-center">
            <i className="ri-chat-3-line text-background-50 text-base"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">读者评论</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 ml-11">吃瓜群众的声音 · 真实用户反馈</p>

        <div className="ml-11 space-y-4">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200/70 transition-all group"
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    width="80"
                    height="80"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="font-semibold text-sm text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">{item.text}</p>
                  <div className="flex items-center gap-4">
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-thumb-up-line"></i>
                      <span>{item.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-chat-1-line"></i>
                      <span>回复</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                      <i className="ri-share-line"></i>
                      <span>分享</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}